export default {"src":"/_next/static/media/Oops.71aab031.svg","height":145,"width":322};